import { render } from "./PartnerListPage.vue?vue&type=template&id=55f830bb&ts=true"
import script from "./PartnerListPage.vue?vue&type=script&lang=ts"
export * from "./PartnerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__